module.exports = __webpack_public_path__ + "static/media/robotoi1.f8b1df51.woff2";